import {
  boxShadow,
  container,
  defaultFont,
  drawerWidth,
  hexToRgb,
  whiteColor,
} from "assets/jss/material-kit-pro-react.js";

const darkBase = "#4a2934";
const lineColor = "rgba(255,255,255,0.14)";
const gold = "#d4b37f";

const headerStyle = (theme) => ({
  appBar: {
    display: "flex",
    width: "100%",
    color: whiteColor,
    background: `linear-gradient(180deg, rgba(74,41,52,0.92) 0%, rgba(92,51,64,0.76) 100%)`,
    boxShadow: "0 22px 45px rgba(58, 30, 40, 0.2)",
    borderBottom: `1px solid ${lineColor}`,
    backdropFilter: "blur(16px)",
    transition: "background 180ms ease, box-shadow 180ms ease, border-color 180ms ease",
    alignItems: "center",
    flexFlow: "row nowrap",
    justifyContent: "flex-start",
    position: "relative",
  },
  absolute: {
    position: "absolute",
    top: "auto",
  },
  fixed: {
    position: "fixed",
  },
  container: {
    ...container,
    minHeight: "84px",
    alignItems: "center",
    justifyContent: "space-between",
    display: "flex",
    flexWrap: "nowrap",
    [theme.breakpoints.down("sm")]: {
      minHeight: "74px",
    },
  },
  title: {
    letterSpacing: "unset",
    padding: 0,
    "&,& a": {
      ...defaultFont,
      minWidth: "unset",
      lineHeight: "1.1",
      fontSize: "18px",
      fontWeight: 600,
      borderRadius: "0",
      textTransform: "none",
      whiteSpace: "nowrap",
      color: "inherit",
      letterSpacing: "0.06em",
      textDecoration: "none",
      "&:hover,&:focus": {
        color: "inherit",
        background: "transparent",
      },
    },
  },
  appResponsive: {
    margin: "60px 18px 20px",
    marginTop: "60px",
  },
  primary: {
    background: `linear-gradient(180deg, rgba(74,41,52,0.95) 0%, rgba(92,51,64,0.85) 100%)`,
    color: whiteColor,
  },
  info: {
    background: `linear-gradient(180deg, rgba(74,41,52,0.95) 0%, rgba(92,51,64,0.85) 100%)`,
    color: whiteColor,
  },
  success: {
    background: `linear-gradient(180deg, rgba(74,41,52,0.95) 0%, rgba(92,51,64,0.85) 100%)`,
    color: whiteColor,
  },
  warning: {
    background: `linear-gradient(180deg, rgba(74,41,52,0.95) 0%, rgba(92,51,64,0.85) 100%)`,
    color: whiteColor,
  },
  danger: {
    background: `linear-gradient(180deg, rgba(74,41,52,0.95) 0%, rgba(92,51,64,0.85) 100%)`,
    color: whiteColor,
  },
  rose: {
    background: `linear-gradient(180deg, rgba(74,41,52,0.95) 0%, rgba(92,51,64,0.85) 100%)`,
    color: whiteColor,
  },
  transparent: {
    backgroundColor: "transparent !important",
    boxShadow: "none",
    borderBottom: "1px solid transparent",
    paddingTop: "12px",
    color: whiteColor,
  },
  dark: {
    color: whiteColor,
    background: `linear-gradient(180deg, rgba(74,41,52,0.97) 0%, rgba(92,51,64,0.92) 100%) !important`,
    boxShadow: "0 24px 46px rgba(58, 30, 40, 0.24)",
    borderBottom: `1px solid rgba(212, 179, 127, 0.18)`,
  },
  white: {
    color: whiteColor,
    background: `linear-gradient(180deg, rgba(74,41,52,0.97) 0%, rgba(92,51,64,0.92) 100%) !important`,
    boxShadow: "0 24px 46px rgba(58, 30, 40, 0.24)",
    borderBottom: `1px solid rgba(212, 179, 127, 0.18)`,
  },
  drawerPaper: {
    border: "none",
    transitionProperty: "top, bottom, width",
    transitionDuration: ".2s, .2s, .35s",
    transitionTimingFunction: "linear, linear, ease",
    width: drawerWidth,
    ...boxShadow,
    position: "fixed",
    display: "block",
    top: "0",
    height: "100vh",
    right: "0",
    left: "auto",
    visibility: "visible",
    overflowY: "auto",
    textAlign: "left",
    paddingRight: "0px",
    paddingLeft: "0",
    background: `linear-gradient(180deg, rgba(74,41,52,0.99) 0%, rgba(98,55,70,0.99) 100%)`,
    color: whiteColor,
  },
  hidden: {
    width: "100%",
  },
  collapse: {
    [theme.breakpoints.up("md")]: {
      display: "flex !important",
      MsFlexPreferredSize: "auto",
      flexBasis: "auto",
      justifyContent: "flex-end",
    },
    WebkitBoxFlex: "1",
    MsFlexPositive: "1",
    flexGrow: "1",
    WebkitBoxAlign: "center",
    MsFlexAlign: "center",
    alignItems: "center",
  },
  closeButtonDrawer: {
    position: "absolute",
    right: "12px",
    top: "12px",
    zIndex: "1",
    color: whiteColor,
  },
  mobileMenuButton: {
    color: whiteColor,
    border: `1px solid ${lineColor}`,
    background: "rgba(255,255,255,0.06)",
    borderRadius: "16px",
    padding: "10px",
  },
  goldAccent: {
    color: gold,
  },
  subtleLine: {
    color: `rgba(${hexToRgb(darkBase)}, 0.22)`,
  },
});

export default headerStyle;
